document.addEventListener('DOMContentLoaded', () => {
  let applied = false;
  new MutationObserver((mutationList, observer) => {
    const form = document.querySelector('#app-embed');
    for (const mutation of mutationList) {
      if (mutation.type === 'childList' && form && form.shadowRoot && !applied) {
        let style = document.createElement('style');
        style.innerHTML =
          ':host {\n' +
          '  --forms-body-font: normal 400 14px var(--font-body-family);\n' +
          '  --forms-heading-font: normal 600 22px var(--font-body-family);\n' +
          '}';
        form.shadowRoot.appendChild(style);
        applied = true;
        observer.disconnect()
      }
    }
  }).observe(document.body, { childList: true });
});
